const key = 'ui'
export default key
